export {
  ModuleIcon,
  ModuleIcon as SidebarModuleIcon,
  SidebarModuleIcon as SidebarSvgIcon,
} from "../module-icon";
